(function () {
  "use strict";

// [module] src/runtime/modules/easylockdown/helper.mjs
function getConfigNode() {
  return document.getElementById("easylockdown-helper-config");
}

function shouldLogFailOpen(configNode) {
  if (!configNode) {
    return false;
  }
  return configNode.getAttribute("data-log-fail-open") === "true";
}

function failOpen(configNode) {
  try {
    var contentBlocks = document.querySelectorAll("div.easylockdown-content");
    for (var i = 0; i < contentBlocks.length; i += 1) {
      contentBlocks[i].style.display = "";
    }

    var helperBlocks = document.querySelectorAll(
      "#easylockdown-password-form, #easylockdown-hpbtn-style, .easylockdown-auto-hl-styles, .easylockdown-custom-hl-styles"
    );
    for (var j = 0; j < helperBlocks.length; j += 1) {
      helperBlocks[j].remove();
    }

    var lock404 = document.getElementById("easylockdown404");
    if (lock404) {
      lock404.style.display = "none";
    }

    document.documentElement.setAttribute("data-easylockdown-failed", "true");

    if (shouldLogFailOpen(configNode) && window.console && typeof window.console.warn === "function") {
      window.console.warn("EasyLockdown script unavailable; rendering storefront content fallback.");
    }
  } catch (error) {}
}

function hasVisibleLockdownSurface() {
  var contentBlocks = document.querySelectorAll("div.easylockdown-content");
  for (var i = 0; i < contentBlocks.length; i += 1) {
    var contentNode = contentBlocks[i];
    if (contentNode && contentNode.offsetParent !== null) {
      return true;
    }
  }

  var passwordForm = document.getElementById("easylockdown-password-form");
  if (passwordForm && passwordForm.offsetParent !== null) {
    return true;
  }

  var lock404 = document.getElementById("easylockdown404");
  if (lock404 && lock404.offsetParent !== null) {
    return true;
  }

  return false;
}

function initEasyLockdownHelper() {
  var config = getConfigNode();
  if (!config) {
    return;
  }

  var retries = 40;
  var intervalMs = 100;
  var attempts = 0;
  var allowPurchase = config.getAttribute("data-hidden-purchase") !== "true";
  var watchdogTimer = null;

  function setWatchdog() {
    if (watchdogTimer) {
      window.clearTimeout(watchdogTimer);
    }
    watchdogTimer = window.setTimeout(function () {
      if (!hasVisibleLockdownSurface()) {
        failOpen(config);
      }
    }, 2500);
  }

  function tryInit() {
    if (
      typeof window.easylockdown === "object" &&
      typeof window.easylockdown.clientContentToggle === "function"
    ) {
      try {
        window.easylockdown.clientContentToggle(allowPurchase);
        setWatchdog();
        return;
      } catch (error) {
        // Retry until helper is fully ready, then fail-open if needed.
      }
    }

    attempts += 1;
    if (attempts >= retries) {
      failOpen(config);
      return;
    }

    window.setTimeout(tryInit, intervalMs);
  }

  tryInit();
  setWatchdog();
}

// [module] src/runtime/entries/easylockdown-helper.mjs

(function () {
  initEasyLockdownHelper();
})();

})();
